import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  LinearProgress,
  Grid2 as Grid,
  Divider,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Settings, CodeDetails, Donation } from "../../../shared/types";
import { getCardImage } from "../../../shared/utilities/actions";
import { convertToCurrency } from "../../../shared/utilities/tools";
import * as consts from "../../../shared/utilities/consts";

export interface ConfirmationProps {
  settings: Settings;
  codeDetails: CodeDetails;
  busy: boolean;
  donations: Donation[];
  handleClose: () => void;
}

export const Confirmation = ({
  settings,
  codeDetails,
  busy,
  donations,
  handleClose,
}: ConfirmationProps): React.JSX.Element => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));
  const [src, SetSrc] = useState<Blob | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (codeDetails?.code) {
        let srcResponse: Blob = await getCardImage(codeDetails.code);
        SetSrc(srcResponse);
      }
    };
    fetchData();
  }, [codeDetails]);

  let currentDonationAmount = 0;
  donations.map((donation) => {
    currentDonationAmount += donation.amount;
  });

  return (
    <Dialog open={true} onClose={handleClose} fullScreen={mobile}>
      <DialogTitle>
        {settings.confirmationDetails.title
          ? `${settings.confirmationDetails.title}`
          : `Donation Summary`}
      </DialogTitle>
      <DialogContent>
        <Grid size={{ xs: 12 }} container spacing={1}>
          {settings.confirmationDetails.displayCardImage && (
            <Grid
              size={{ xs: 12 }}
              sx={{ marginBottom: mobile ? "16px" : "24px" }}
            >
              {src ? (
                <img
                  src={URL.createObjectURL(src)}
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    margin: "auto",
                    border: "1px solid rgb(242 242 242)",
                    borderRadius: "22px",
                    backgroundColor: "rgb(242 242 242)",
                  }}
                />
              ) : (
                <img
                  src={`${consts.BLOB_URL}/v4-system-assets/CardImagePlaceholder.gif`}
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    margin: "auto",
                    border: "1px solid rgb(242 242 242)",
                    borderRadius: "22px",
                    backgroundColor: "rgb(242 242 242)",
                  }}
                />
              )}
            </Grid>
          )}
          <Grid size={{ xs: 12 }}>
            {settings.confirmationDetails.displaySelectedCharities &&
              donations.length > 0 && (
                <Grid size={{ xs: 12 }} container spacing={1}>
                  {donations.map((donation) => {
                    return (
                      <React.Fragment key={donation.ein}>
                        <Grid size={{ xs: 10 }}>
                          <Typography variant="body1">{`${donation.name}`}</Typography>
                        </Grid>
                        <Grid size={{ xs: 2 }} style={{ textAlign: "right" }}>
                          <Typography variant="body1">{`${convertToCurrency(
                            donation.amount
                          )}`}</Typography>
                        </Grid>
                      </React.Fragment>
                    );
                  })}
                </Grid>
              )}
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Divider />
          </Grid>
          <Grid size={{ xs: 12 }} container spacing={1}>
            <Grid size={{ xs: 6 }}>
              <Typography variant="body1">Remaining Balance:</Typography>
            </Grid>
            <Grid size={{ xs: 6 }} style={{ textAlign: "right" }}>
              <Typography variant="body1">
                {convertToCurrency(
                  codeDetails.availableAmount - currentDonationAmount
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Typography
              variant="body1"
              component="div"
              dangerouslySetInnerHTML={{
                __html: settings.confirmationDetails.markup,
              }}
            ></Typography>
          </Grid>
          {mobile && (
            <Grid size={{ xs: 12 }}>
              <Button
                onClick={handleClose}
                fullWidth={true}
                style={{ marginTop: "24px" }}
              >
                Continue
              </Button>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      {!mobile && (
        <DialogActions sx={{ padding: "24px" }}>
          <Button onClick={handleClose}>Continue</Button>
        </DialogActions>
      )}
      {busy && <LinearProgress />}
    </Dialog>
  );
};
